import { useMediaQuery } from '@mantine/hooks';
import { Notifications } from '@mantine/notifications';

export function AppNotifications() {
  const isMobile = useMediaQuery('(max-width: 48em)');

  return (
    <Notifications position={isMobile ? 'top-center' : 'top-right'} autoClose={4500} limit={4} />
  );
}
